/**
 * The name of the bundled audio file which will be played when timer is completed.
 *
 * @type {string}
 */
export const TIMER_OFF_SOUND_FILE = 'timerOff.wav';